import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

import { InstructionBody, UNKNOWN_INSTRUCTION } from '../DeliveryStatusCard/constants';

interface Props {
  body: InstructionBody;
  onDismiss: () => void;
}

export default function InstructionInfoPanel({ body, onDismiss }: Props) {
  const isUnknown = body === UNKNOWN_INSTRUCTION;

  return (
    <Alert
      severity={isUnknown ? 'warning' : 'info'}
      icon={isUnknown ? undefined : <InfoOutlinedIcon fontSize="small" />}
      sx={{ borderRadius: 1 }}
    >
      <Typography variant="subtitle2" fontWeight={600} gutterBottom>
        {body.title}
      </Typography>
      <Stack component="ul" spacing={0.5} sx={{ m: 0, pl: 2 }}>
        {body.instructions.map((step, idx) => (
          <Typography key={idx} component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
            {step}
          </Typography>
        ))}
      </Stack>
      <Box sx={{ mt: 1.5 }}>
        <Button variant="text" size="small" onClick={onDismiss}>
          Dismiss
        </Button>
      </Box>
    </Alert>
  );
}
